module.exports = __webpack_public_path__ + "img/register_icon_key.4ce50606.svg";